import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { white } from '@material-ui/core/colors';
import { Switch } from '@material-ui/core';

// Icons
import LockIcon from 'mdi-react/LockIcon';

const CustomSwitch = withStyles({
  switchBase: {
    color: white,
    '&$checked': {
      color: '#177EFF',
    },
    '&$checked + $bar': {
      backgroundColor: '#177EFF',
    }
  },
  checked: {},
  bar: {},
})(Switch);

export default (props) => {
  if (!!props.disabled) {
    return (
      <CustomSwitch
        { ...props.input }
        checked={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        disabled={props.disabled}
        icon={<LockIcon size={12}/>}
      />
    )
  } else {
    return (
      <CustomSwitch
        { ...props.input }
        checked={props.input.value}
        onChange={(value) => props.input.onChange(value)}
        disabled={props.justDisabled}
      />
    )
  }
} // END SwitchMaterial



// WEBPACK FOOTER //
// ./src/components/form/SwitchMaterial.js